import React from "react";

import { Doc } from "affinityUI/structures/doc";

import addPatientLink from "./assets/Add patient link.png";
import addPatientPage from "./assets/Add patient page.png";
import createPatientConfirmation from "./assets/Confirm patient information.png";
import reviewPatientPage from "./assets/Review patient page.png";

export const AddPatientSection: React.FC = () => {
  return (
    <Doc.Section title="Add Patient">
      <p>
        To add a patient to the Entia Liberty Dashboard, click the “Add patient” link. After clicking on the “Add
        patient” link, the Add Patient page will be opened.
      </p>
      <Doc.Note>
        <strong>Please note:</strong> your user profile must have permission to add a patient. The link will not be
        visible if access to this functionality is not allowed. If such situation occurs and you need access to this
        functionality, please contact the Entia support team.
      </Doc.Note>
      <Doc.Illustration src={addPatientLink} label="Add patient link" />
      <Doc.Illustration src={addPatientPage} label="Add patient page" />
      <p>
        Add patient page allows you to enter the patient’s personal details. Corresponding information needs to be
        entered into all fields. If the field is marked as “optional” then this can remain empty.
      </p>
      <p>
        After entering all data about the patient, press the “Continue to confirmation” button. The application will
        perform a check on the following conditions:
      </p>
      <ul>
        <li>All required fields are filled in</li>
        <li>The email format is valid</li>
        <li>The phone number format is valid</li>
        <li>The NHS number is correct</li>
        <li>Postcode is correct</li>
        <li> The hospital number is unique</li>
      </ul>
      <p>
        If at least one of the conditions above is incorrect, a corresponding error message will appear. To be able to
        see what field the error message is related to, you need to click on the error message itself.
      </p>
      <p>
        If all the listed conditions are correct, clicking on the “Continue to confirmation” button will open the
        Confirmation page.
      </p>
      <Doc.Illustration src={createPatientConfirmation} label="Confirm patient information" />
      <p>
        This page allows you to double check entered information and make changes if necessary. The “Edit” link or back
        button will open Add Patient page with all the information recently entered. Clicking the “Cancel” button will
        redirect you to the list of the Patients and all the changes will be discarded. Therefore the patient will not
        be registered.
      </p>
      <p>
        The “Confirm and save patient info” button will save all early entered details and add this patient to the list
        of patients. The Review Patient page will be opened.
      </p>

      <p>This page contains the following sections:</p>

      <ul>
        <li>Patient Details</li>
        <li>Device Details</li>
        <li>Results history</li>
      </ul>
      <Doc.Illustration src={reviewPatientPage} label="Review patient page" />
    </Doc.Section>
  );
};
